<template>
  <div class="main" id="main" style="margin: 0">
    <div class="title flex_c">
      <div class="logo"></div>
      <div class="txt">运友邦车队运营看板</div>
      <div v-show="fullscreen == false" class="quan" @click="toggleFullScreen"></div>
      <div v-show="fullscreen == true" class="guan" @click="exitFullScreen"></div>
    </div>
    <div class="tips">
      您好，今天是{{ YEAR }}年{{ MONTH }}月{{ DAY }}日，本月已经过去了{{
        PERCENT
      }}%
    </div>
    <div class="row row0 flex_b">
      <div class="card col0">
        <div class="tit flex_b">
          <div class="left">本月收入统计</div>
          <div class="right">
            <div class="ico"></div>
          </div>
        </div>
        <div class="cont flex_b">
          <div class="item">
            <div class="label">运费总额</div>
            <div class="value">{{ income.freight }}</div>
          </div>
          <div class="item">
            <div class="label">运单数量</div>
            <div class="value">{{ income.order_num }}</div>
          </div>
          <div class="item">
            <div class="label">毛利额</div>
            <div class="value">{{ income.margin }}</div>
          </div>
          <div class="item">
            <div class="label">毛利率</div>
            <div class="value">{{ income.gross_profit }}%</div>
          </div>
        </div>
      </div>

      <div class="card col1">
        <div class="tit flex_b">
          <div class="left">本月费用统计</div>
          <div class="right">
            <div class="ico ico2"></div>
          </div>
        </div>
        <div class="cont flex_b">
          <div class="item">
            <div class="label">出车费用</div>
            <div class="value">{{ expense.out_fee }}</div>
          </div>
          <div class="item">
            <div class="label">固定费用</div>
            <div class="value">{{ expense.fixed_fee }}</div>
          </div>
          <div class="item">
            <div class="label">维保费用</div>
            <div class="value">{{ expense.repair_fee }}</div>
          </div>
          <div class="item">
            <div class="label">附加费用</div>
            <div class="value">{{ expense.info_fee }}</div>
          </div>
        </div>
      </div>

      <div class="card col2">
        <div class="tit flex_b">
          <div class="left">本年经营概览</div>
          <div class="right">
            <div class="ico ico3"></div>
          </div>
        </div>
        <div class="cont flex_b">
          <div class="item">
            <div class="label">运费总额</div>
            <div class="value">{{ overview.freight }}</div>
          </div>
          <div class="item">
            <div class="label">费用合计</div>
            <div class="value">{{ overview.total_fee }}</div>
          </div>
          <div class="item">
            <div class="label">毛利额</div>
            <div class="value">{{ overview.margin }}</div>
          </div>
          <div class="item">
            <div class="label">应收账款</div>
            <div class="value">{{ overview.receivables }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row1 flex_b">
      <div class="card col1">
        <div class="tit flex_b">
          <div class="left">车务管理概览</div>
        </div>
        <div class="cont">
          <div class="r1 flex_b">
            <div class="l">
              <div class="p">
                <div class="v" :style="`width: ${(vehicle.onway_num / vehicle.vehicle_num) * 100
                  }%;`"></div>
              </div>
              <div class="d flex">
                <div class="item">
                  <div class="wrap flex">
                    <div class="label">车辆总数：</div>
                    <div class="value">{{ vehicle.vehicle_num }}</div>
                  </div>
                </div>

                <div class="item">
                  <div class="wrap flex">
                    <div class="label">工作中车辆：</div>
                    <div class="value">{{ vehicle.onway_num }}</div>
                  </div>
                </div>

                <div class="item">
                  <div class="wrap flex">
                    <div class="label">休息中车辆：</div>
                    <div class="value">{{ vehicle.rest_num }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="r flex_b">
              <div class="wrap">
                <div class="label">实时运力池(吨)</div>
                <div class="value">{{ vehicle.rest_carCapacity }}</div>
              </div>

              <div class="wrap">
                <div class="label">车辆资产余额</div>
                <div class="value">{{ vehicle.asset_balance }}</div>
              </div>
            </div>
          </div>
          <div class="r2 flex_b">
            <div class="item">
              <div class="wrap">
                <div class="label">近30天到期证件数量</div>
                <div class="value">{{ vehicle.expire_num }}</div>
              </div>
            </div>

            <div class="item">
              <div class="wrap">
                <div class="label">近30天到期保险数量</div>
                <div class="value">{{ vehicle.insurance_num }}</div>
              </div>
            </div>

            <div class="item">
              <div class="wrap">
                <div class="label">本月违章次数</div>
                <div class="value">{{ vehicle.violation_num }}</div>
              </div>
            </div>

            <div class="item">
              <div class="wrap">
                <div class="label">本月罚款金额</div>
                <div class="value">{{ vehicle.fine_amount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card col2">
        <div class="tit flex_b">
          <div class="left">近30天车辆利用率走势图</div>
        </div>
        <div class="cont">
          <div class="chart" id="chart1"></div>
        </div>
      </div>
    </div>

    <div class="row row2 flex_b">
      <div class="card col1">
        <div class="tit">
          <div class="left">近30天运费收入/运单数量走势图</div>
        </div>
        <div class="cont">
          <div class="chart" id="chart2"></div>
        </div>
      </div>

      <div class="card col2">
        <div class="tit">
          <div class="left">车队对比分析</div>
        </div>
        <div class="cont">
          <div class="chart" id="chart3"></div>
        </div>
      </div>

      <div class="card col3">
        <div class="tit flex_b">
          <div class="left">车队费用分析</div>
          <div class="right flex">
            <el-form :inline="true" :model="form">
              <FormItem v-for="(c, i) in formCtrl" :key="'search' + i" :config="c" :options="c.options"
                :inputValue="form[c.keyName]" @onChange="onChange" />
            </el-form>
          </div>
        </div>
        <div class="cont">
          <div class="chart" id="chart4"></div>
          <div class="btn hide" id="closeBtn"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      baseUrl: "dashboard",
      fleetData: [{ label: "全部", value: 0 }],
      fullscreen: false,
      chart0: null,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      pieLabelStyle: {
        width: 90,
        color: "inherit", // 继承系列色
        formatter: "{b}\n{val|{c}}", // 上名下值
        // formatter: '{val|{c}}\n{b}', // 上值下名
        lineHeight: 15,
        rich: {
          // b: {
          //   overflow: 'break',
          // },
          val: {
            color: "#fff",
          },
        },
        distanceToLabelLine: 0,
        // overflow: 'break',
      },
      pieLabelLineStyle: {
        show: false,
        length: 28,
        length2: 5,
      },
      YEAR: "0000",
      MONTH: "00",
      DAY: "00",
      PERCENT: "0",
      formCtrl: [
        {
          label: "",
          keyName: "fleet",
          type: "select",
          placeholder: "选择车队长",
          options: [{ label: "全部", value: 0 }],
        },
      ],
      form: {},
      income: {},
      expense: {},
      overview: {},
      vehicle: {},
      legendConfig: {
        show: true,
        left: "center",
        top: 15,
        itemGap: 20,
        inactiveColor: "#6C8097",
        textStyle: {
          color: "#fff",
          padding: [115, 0, 0, 0],
        },
      },
    };
  },
  methods: {
    toggleFullScreen() {
      // 进入全屏
      document.documentElement.requestFullscreen();
      this.$router.push("/Indexs");
    },
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen(); // 标准化
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen(); // WebKit浏览器
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen(); // Firefox
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen(); // IE/Edge
      }
      this.$router.push("/admin/index");
    },
    fleetChange(v) {
      console.log(v);
    },
    getData() {
      this.getIncome();
      this.getExpense();
      this.getOverview();
      this.getVehicleDate();
      this.getUtilization();
      this.getIncomeTrend();
      this.getTeam();
      this.getExpenseAnalysis();
    },
    getIncome() {
      this.loading = true;
      let url = `${this.baseUrl}/income`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg !== "success" || !data) {
            this.$message({
              type: "error",
              message: msg,
            });
            return;
          }
          // console.log({ ...data })
          this.income = data;
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    getExpense() {
      this.loading = true;
      let url = `${this.baseUrl}/expense`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg !== "success" || !data) {
            this.$message({
              type: "error",
              message: msg,
            });
            return;
          }
          // console.log({ ...data })
          this.expense = data;
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    getOverview() {
      this.loading = true;
      let url = `${this.baseUrl}/overview`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg !== "success" || !data) {
            this.$message({
              type: "error",
              message: msg,
            });
            return;
          }
          // console.log({ ...data })
          this.overview = data;
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    getVehicleDate() {
      this.loading = true;
      let url = `${this.baseUrl}/vehicle`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg !== "success" || !data) {
            this.$message({
              type: "error",
              message: msg,
            });
            return;
          }
          // console.log({ ...data })
          this.vehicle = data;
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    getUtilization() {
      this.loading = true;
      let url = `${this.baseUrl}/utilization`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg !== "success" || !data) {
            this.$message({
              type: "error",
              message: msg,
            });
            return;
          }
          // console.log({ ...data })
          const xAxis = [];
          const yAxis = [];
          data.map((v) => {
            if (v.day) {
              xAxis.push(v.day.split("-")[2]);
            }
            yAxis.push(v.utilization_rate);
          });
          this.setUtilization(xAxis, yAxis);
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    setUtilization(data0, data1) {
      // console.log(data0, data1)
      this.chart1 = this.$echarts.init(document.getElementById("chart1"));
      // 折线图配置项
      const option = {
        grid: {
          left: 50,
          right: 30,
          bottom: 38,
        },
        legend: {
          ...this.legendConfig,
          data: ["利用率"],
        },
        xAxis: {
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            width: 30,
            overflow: "break",
          },
          data: data0,
        },
        yAxis: {
          type: "value",
          splitNumber: 5,
          axisLabel: {
            show: true,
            interval: "auto", //居中显示
            formatter: "{value} %", //以百分比显示
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(108,128,151,0.3)",
            },
          },
        },
        series: {
          name: "利用率",
          type: "line",
          symbol: "none",
          itemStyle: {
            color: "#EF6F2E",
          },
          smooth: true,
          data: data1,
        },
      };
      this.chart1.setOption(option);
    },
    getIncomeTrend() {
      this.loading = true;
      let url = `${this.baseUrl}/incomeTrend`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg !== "success" || !data) {
            this.$message({
              type: "error",
              message: msg,
            });
            return;
          }
          // console.log({ ...data })
          const xAxis = [];
          const yAxis1 = [];
          const yAxis2 = [];
          data.map((v) => {
            if (v.day) {
              xAxis.push(v.day.split("-")[2]);
            }
            yAxis1.push(v.freight / 10000);
            yAxis2.push(v.order_num);
          });
          this.setIncomeTrend(xAxis, yAxis1, yAxis2);
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    setIncomeTrend(data0, data1, data2) {
      // console.log(data0, data1, data2)
      this.chart2 = this.$echarts.init(document.getElementById("chart2"));
      // 折线图配置项
      const option = {
        // 设置图表边距
        grid: {
          left: 70,
          right: 50,
          bottom: 38,
        },
        legend: {
          ...this.legendConfig,
          data: ["运费收入", "运单数量"],
        },
        xAxis: {
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            width: 30,
            overflow: "break",
          },
          data: data0,
        },
        yAxis: [
          {
            type: "value",
            // name: '单位：万元',
            nameGap: 23,
            // interval: 500,
            // axisLabel: {
            //   show: true,
            //   interval: 'auto',//居中显示
            //   formatter: '{value} 万'//以百分比显示
            // },
            splitNumber: 5,
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            splitNumber: 5,
            // axisLabel: {
            //   show: true,
            //   interval: 'auto',//居中显示
            //   formatter: '{value} %'//以百分比显示
            // },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(108,128,151,0.3)",
              },
            },
          },
        ],
        series: [
          {
            name: "运费收入",
            type: "line",
            yAxisIndex: 0,
            symbol: "none",
            itemStyle: {
              color: "#1598FB",
            },
            smooth: true,
            data: data1,
          },
          {
            name: "运单数量",
            type: "line",
            yAxisIndex: 1,
            symbol: "none",
            label: {
              show: true,
              fontSize: 12,
            },
            itemStyle: {
              color: "#2DD2A5",
            },
            smooth: true,
            data: data2,
          },
        ],
      };
      this.chart2.setOption(option);
    },
    getTeam() {
      this.loading = true;
      let url = `${this.baseUrl}/team`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg !== "success" || !data) {
            this.$message({
              type: "error",
              message: msg,
            });
            return;
          }
          // console.log({ ...data })
          const xAxis = [];
          const yAxis1 = [];
          const yAxis2 = [];
          const yAxis3 = [];
          data.map((v) => {
            xAxis.push(v.nickname);
            yAxis1.push(v.freight / 10000);
            yAxis2.push(v.total_fee / 10000);
            yAxis3.push(v.margin / 10000);
          });
          this.setTeam(xAxis, yAxis1, yAxis2, yAxis3);
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    setTeam(data0, data1, data2, data3) {
      // console.log(data0, data1, data2, data3)
      this.chart3 = this.$echarts.init(document.getElementById("chart3"));
      const option = {
        // 设置图表边距
        grid: {
          left: 60,
          right: 20,
          bottom: 38,
        },
        legend: {
          ...this.legendConfig,
          itemWidth: 8,
          itemHeight: 8,
          data: ["运费收入", "费用支出", "毛利额"],
        },
        xAxis: {
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            width: 30,
            overflow: "break",
          },
          data: data0,
        },
        yAxis: {
          type: "value",
          nameGap: 23,
          splitNumber: 5,
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(108,128,151,0.3)",
            },
          },
        },
        series: [
          {
            name: "运费收入",
            type: "bar",
            symbol: "none",
            itemStyle: {
              color: "#159AFF",
            },
            smooth: true,
            data: data1,
          },
          {
            name: "费用支出",
            type: "bar",
            symbol: "none",
            itemStyle: {
              color: "#EF6F2E",
            },
            smooth: true,
            data: data2,
          },
          {
            name: "毛利额",
            type: "bar",
            symbol: "none",
            itemStyle: {
              color: "#2DD2A5",
            },
            smooth: true,
            data: data3,
          },
        ],
      };
      this.chart3.setOption(option);
    },
    getExpenseAnalysis() {
      this.loading = true;
      let url = `${this.baseUrl}/ExpenseAnalysis`;
      if (this.form.fleet == 0) {
        delete this.form.fleet;
      }
      const params = {
        // userid: this.user.id,
        ...this.form,
      };
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg !== "success" || !data) {
            this.$message({
              type: "error",
              message: msg,
            });
            return;
          }
          // console.log({ ...data })
          const xAxis = [];
          xAxis.push({
            name: "出车费用",
            value: this.toNumber(data["daypay"].total),
            detail: this.dataPipe(data["daypay"].detail),
          });
          xAxis.push({
            name: "固定费用",
            value: this.toNumber(data["fixedpay"].total),
            detail: this.dataPipe(data["fixedpay"].detail),
          });
          xAxis.push({
            name: "维保费用",
            value: this.toNumber(data["repair"].total),
            detail: this.dataPipe(data["repair"].detail),
          });
          xAxis.push({
            name: "附加费用",
            value: this.toNumber(data["infofee"].total),
            detail: this.dataPipe(data["infofee"].detail),
          });
          this.setExpenseAnalysis(xAxis);
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    toNumber(n) {
      let s = `${n}`;
      let s1 = s.replace(",", "");
      let n1 = Number(s1);
      // console.log(n1)
      return n1;
    },
    dataPipe(object) {
      const arr = [];
      if (object) {
        for (const key in object) {
          if (Object.prototype.hasOwnProperty.call(object, key)) {
            const element = object[key];
            arr.push({
              name: key,
              value: this.toNumber(element),
            });
          }
        }
      }
      return arr;
    },
    setExpenseAnalysis(data) {
      // console.log(data)
      this.chart4 = this.$echarts.init(document.getElementById("chart4"));
      // 环形图配置项
      const optionConfig = {
        type: "pie",
        radius: [44, 60],
        label: {
          ...this.pieLabelStyle,
        },
        labelLine: {
          ...this.pieLabelLineStyle,
        },
        color: [
          "#5087EC",
          "#2DD285",
          "#EE752F",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        itemStyle: {
          normal: {
            borderWidth: 5,
          },
        },
      };
      const option = {
        series: [
          {
            ...optionConfig,
            data,
          },
        ],
      };
      this.chart4.setOption(option);

      const cbtn = document.querySelector("#closeBtn");

      // 绑定点击事件，点击刷新数据
      this.chart4.on("click", (params) => {
        // console.log(params)
        if (params && params.data && params.data.detail) {
          cbtn.classList.remove("hide");
          this.chart4.setOption({
            series: [
              {
                ...optionConfig,
                data: params.data.detail,
              },
            ],
          });
        }
      });

      cbtn.addEventListener("click", () => {
        // console.log(cbtn)
        cbtn.classList.add("hide");
        this.chart4.setOption({
          series: [
            {
              ...optionConfig,
              data,
            },
          ],
        });
      });
    },
    getFleetData() {
      this.loading = true;
      let url = `dashboard/getfleet`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ fleet }) => {
          console.log("车队长数据", fleet);
          // if (!fleet) {
          //   this.$message({
          //     type: 'warning',
          //     message: '加载失败，请稍后再试！',
          //   });
          //   return
          // }
          if (Array.isArray(fleet)) {
            fleet.map((v) => {
              console.log(v);
              const o = {
                label: v.nickname,
                value: v.id,
              };
              this.formCtrl[0].options.push(o);
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    onChange({ key, value }) {
      console.log(key, value);
      this.form[key] = value;
      // console.log({ ...this.form });
      this.getExpenseAnalysis();
    },
    initDate() {
      const date = new Date();
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      this.YEAR = y;
      this.MONTH = m;
      this.DAY = d;
      // m > 9 ? null : m = '0' + m
      // d > 9 ? null : d = '0' + d
      // console.log((d / 28).toFixed(2), (d / 29).toFixed(2), (d / 30).toFixed(2), (d / 31).toFixed(2))
      let per = d / 28;
      if (m == 2) {
        if ((y % 4 == 0 && y % 100 != 0) || y % 400 == 0) {
          per = d / 29;
        }
      } else if ([1, 3, 5, 7, 8, 10, 12].includes(m)) {
        per = d / 31;
      } else {
        per = d / 30;
      }
      this.PERCENT = (per * 100).toFixed(2);
    },
  },
  mounted() {
    const date = new Date();
    const y = date.getFullYear();
    let m = date.getMonth() + 1;
    m > 9 ? null : (m = "0" + m);
    this.form.month = `${y}-${m}`;
    this.getData();
    this.initDate();
    this.getFleetData();
    // console.log(this.$route.path)
    if (this.$route.path == "/Indexs") {
      this.fullscreen = true;
    } else {
      this.fullscreen = false;
    }
  },
};
</script>

<style lang="less" scoped>
@vw: 100vw / 1920;
@vh: 100vh / 1080;

#chart2 {
  position: relative;

  &::after {
    content: '单位：万元';
    position: absolute;
    left: 17px;
    top: 18px;
    color: #6C8097;
    font-size: 12px;
  }
}

#chart3 {
  position: relative;

  &::after {
    content: '单位：万元';
    position: absolute;
    left: 17px;
    top: 16px;
    color: #6C8097;
    font-size: 12px;
  }
}

.main {
  background: url(../assets/img/index_bg.png) no-repeat center center/cover;
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 100%;

  // position: fixed;
  // left: 0;
  // top: 0;
  // width: 100%;
  // height: 100%;
  // overflow-y: scroll;

  .title {
    padding: 15px 0;
    background: url(../assets/img/index_title_bg.png) no-repeat top center;
    position: relative;

    .logo {
      width: 52px;
      height: 40px;
      background: url(../assets/img/logo.png) no-repeat center center;
      background-size: 52px;
      margin-right: 10px;
    }

    .txt {
      height: 43px;
      line-height: 43px;
      font-size: 36px;
      font-family: DingTalk JinBuTi, DingTalk JinBuTi;
      font-weight: 400;
      color: #ffffff;
      letter-spacing: 10px;
      text-shadow: 0px 0px 20px #159aff;
    }

    .quan {
      width: 36px;
      height: 36px;
      background: url(../assets/img/quanping.png) no-repeat;
      background-size: 100%;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }

    .guan {
      width: 36px;
      height: 36px;
      background: url(../assets/img/quanping1.png) no-repeat;
      background-size: 100%;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }

    .right {
      position: absolute;
      right: 80px;

      /deep/ .el-form {
        .el-form-item {
          margin: 0;

          .el-form-item__label {
            color: #fff;
          }

          .el-form-item__content {
            .el-date-editor.el-input {
              width: 120px;

              .el-input__inner {
                height: 30px;
              }
            }
          }
        }
      }
    }
  }

  .tips {
    position: absolute;
    right: 30px;
    left: auto;
    top: 58px;
    font-size: 16px;
    font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
    font-weight: 400;
    color: #f3f9ff;
  }

  .flex {
    display: flex;
  }

  .flex_c {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flex_b {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .card {
    background: rgba(15, 24, 42, 0.9);
    box-sizing: border-box;

    .tit {
      width: 100%;
      height: 48px;
      line-height: 48px;
      padding-left: 52px;
      background: url(../assets/img/index_tit_bg.png) no-repeat top left;
      position: relative;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(225, 225, 225, 0.09);
      font-family: DingTalk JinBuTi, DingTalk JinBuTi;
      font-size: 18px;
      text-shadow: 0px 0px 9px #159aff;
      color: #ffffff;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 47px;
        width: 52px;
        height: 1px;
        background: #ffffff;
      }

      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 45px;
        width: 20px;
        height: 3px;
        background: url(../assets/img/index_tit_bg_3.png) no-repeat top right;
      }
    }

    .cont {
      position: relative;

      // &::before {
      //   content: '';
      //   position: absolute;
      //   left: 0;
      //   bottom: 0;
      //   width: 11px;
      //   height: 11px;
      //   background: url(../assets/img/index_cont_bg_0.png) no-repeat center center;
      // }

      // &::after {
      //   content: '';
      //   position: absolute;
      //   right: 0;
      //   bottom: 0;
      //   width: 11px;
      //   height: 11px;
      //   background: url(../assets/img/index_cont_bg_1.png) no-repeat center center;
      // }
    }
  }

  .card {
    .label {
      font-size: 15px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #f3f9ff;
      height: 15px;
      line-height: 15px;
    }

    // .value {
    //   font-size: 22px;
    //   font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
    //   font-weight: 400;
    //   color: #F3F9FF;
    //   text-shadow: 0px 0px 10px rgba(255, 201, 122, 1);
    //   margin-top: 10px;
    //   height: 26px;
    //   line-height: 26px;
    // }

    .diff {
      margin-top: 20px;
      height: 14px;
      line-height: 14px;

      /deep/ .itemm {
        &:last-of-type {
          .ico {
            margin-right: 0;
          }
        }
      }
    }
  }

  .row0 {
    margin: 21px 40px 30px;

    .card {
      width: 32.23%;
      min-width: 450px;
      height: 166px;

      .tit {
        .right {
          .ico {
            width: 30px;
            height: 26px;
            background: url(../assets/img/index_tit_01.png) no-repeat center center;
            background-size: 100%;
            margin-right: 15px;

            &.ico2 {
              background-image: url(../assets/img/index_tit_02.png);
            }

            &.ico3 {
              background-image: url(../assets/img/index_tit_03.png);
            }
          }
        }
      }

      .cont {
        padding: 30px 25px;
        box-sizing: border-box;

        .item {
          .label {
            font-size: 14px;
            color: #f3f9ff;
          }

          .value {
            font-size: 20px;
            color: #ffffff;
            text-shadow: 0px 0px 9px #159aff;
            margin-top: 15px;
            font-family: DingTalk JinBuTi;
          }

          &:nth-child(4) {
            width: 25.6%;
          }
        }
      }
    }

    .col1 {
      .cont {
        .l {
          background: linear-gradient(90deg,
              #5f71e4 0%,
              rgba(76, 66, 54, 0.1) 100%);
          border-color: #5f71e4;
        }

        .r {
          .ico {
            background-image: url(../assets/img/ico_index_1_2.png);
          }
        }
      }
    }

    .col2 {
      .cont {
        .l {
          background: linear-gradient(90deg,
              #f38842 0%,
              rgba(76, 66, 54, 0.1) 100%);
          border-color: #f38842;
        }

        .r {
          .ico {
            background-image: url(../assets/img/ico_index_1_3.png);
          }
        }
      }
    }
  }

  .circle {
    width: 100%;
    height: 100%;
    position: relative;

    .con {
      width: 100%;
      height: 100%;
    }

    .mask {
      position: absolute;
      width: 52px;
      height: 52px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      background: url(../assets/img/index_circle_bg_1.png) no-repeat center center;
    }
  }

  // 第二行
  .row1 {
    margin: 30px 40px;

    .card {
      height: 323px;

      &.col1 {
        width: 49%;
      }

      &.col2 {
        width: 49.1%;
      }
    }

    // 标题
    .tit {
      .left {
        width: 905px;
      }

      .right {
        width: 50%;
      }
    }

    .cont {
      height: 275px;
    }

    .col1 {
      .cont {
        padding: 35px 25px 25px;
        box-sizing: border-box;

        .r1 {
          .l {
            width: 53.5%;

            .p {
              width: 100%;
              height: 29px;
              background: #414a5b;
              border-radius: 0px 50px 50px 0px;
              position: relative;

              .v {
                height: 100%;
                background: #2dd2a5;
                border-radius: 0px 50px 50px 0px;
                position: absolute;
                left: 0;
                top: 0;
              }
            }

            .d {
              font-weight: 400;
              font-size: 14px;
              color: #f3f9ff;
              margin-top: 15px;

              .item {
                width: 150px;
              }
            }
          }

          .r {
            width: 42.5%;
            margin-left: 10px;

            .wrap {
              width: 46.5%;
              height: 80px;
              background: rgba(108, 128, 151, 0.1);
              padding: 20px 0 20px 20px;
              box-sizing: border-box;
              padding-left: 31px;
              position: relative;

              &::after {
                content: "";
                position: absolute;
                left: 20px;
                top: 21px;
                width: 3px;
                height: 14px;
                background: linear-gradient(#159aff 0%,
                    rgba(21, 154, 255, 0) 100%);
              }

              .label {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 14px;
                color: #d0deee;
                height: 16px;
                line-height: 16px;
              }

              .value {
                margin-top: 8px;
                font-family: DingTalk JinBuTi;
                font-weight: 400;
                font-size: 16px;
                color: #f3f9ff;
              }
            }
          }
        }

        .r2 {
          margin-top: 35px;

          .item {
            width: 22.9%;
            height: 100px;
            background: rgba(15, 24, 42, 0.8);
            border: 1px solid #6c8097;
            padding: 22px 0;
            box-sizing: border-box;
            text-align: center;
            position: relative;
            background: url(../assets/img/index_chewu_item_bg.png) no-repeat center center/cover;

            &::after {
              content: "";
              position: absolute;
              left: 4px;
              top: 4px;
              width: 0;
              height: 0;
              border: 3.5px solid #ff4848;
              border-right-color: transparent;
              border-bottom-color: transparent;
            }

            .label {
              font-weight: 400;
              font-size: 14px;
              color: #f3f9ff;
            }

            .value {
              font-family: DingTalk JinBuTi;
              font-weight: 400;
              font-size: 22px;
              color: #ffffff;
              text-shadow: 0px 0px 9px #159aff;
              margin-top: 11px;
            }
          }
        }
      }
    }
  }

  .chart {
    width: 100%;
    height: 100%;
  }

  .row2 {
    margin: 30px 40px 50px;

    .card {
      height: 323px;

      .cont {
        height: 275px;

        .chart {
          height: 100%;
        }
      }
    }

    .col1 {
      width: 49%;
    }

    .col2 {
      width: 23.7%;
    }

    .col3 {
      width: 23.7%;

      .tit {
        .right {
          font-size: 14px;

          .lab {
            color: #6c8097;
          }

          .val {
            color: #ebf9ff;
            text-shadow: 0px 0px 9px #159aff;
            margin: 0 15px 0 10px;
          }

          /deep/ .el-form-item {
            margin: 0 15px 0;
            display: flex;
            align-items: center;

            .el-input {
              width: 120px;
            }

            .el-input__inner {
              height: 33px;
              line-height: 33px;
              background-color: #050911;
              color: #ffffff;
            }
          }
        }
      }

      .cont {
        position: relative;

        .chart {
          width: 100%;
          height: 100%;
          // 外圈背景
          background: url(../assets/img/index_circle_bg_2.png) no-repeat center center;
        }

        #closeBtn {
          width: 15px;
          height: 15px;
          position: absolute;
          top: 10px;
          right: 10px;
          background: url(../assets/img/close.png) no-repeat center center;
          background-size: 100%;
          cursor: pointer;

          &.hide {
            display: none;
          }
        }
      }
    }
  }
}
</style>
